module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-net.b7c0b885.png";